import React, { memo } from 'react'

import { Skeleton, useMediaQueryContext } from '@fourthwall/components'

import * as S from './ProductsListItem.styled'

export const ProductsListItemSkeleton = memo(() => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <Skeleton.Shape width={24} height={24} />
      <Skeleton.Shape width={media.tablet ? 60 : 42} height={media.tablet ? 80 : 56} />
      <S.ProductInfo>
        <Skeleton.Shape width="50%" height={24} />
        {!media.tablet && <Skeleton.Shape width={70} height={24} />}
      </S.ProductInfo>
      {media.tablet && <Skeleton.Shape width={70} height={24} />}
    </S.Container>
  )
})
